import { Button as AntButton } from 'antd'
// import Avatar from 'boring-avatars'
// import * as _ from 'lodash/fp'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

// import AccessIcon from '@/assets/icons/access.svg?react'
// import ApiIcon from '@/assets/icons/api.svg?react'
// import EducationIcon from '@/assets/icons/education.svg?react'
// import NotificationIcon from '@/assets/icons/notification.svg?react'
// import GiftIcon from '@/assets/icons/gift.svg?react'
import KeyIcon from '@/assets/icons/key.svg?react'
// import PasswordIcon from '@/assets/icons/password.svg?react'
import { Trans } from '@/components'
import { UserAvatar } from '@/components/UserAvatar'
import { ExchangeModal } from '@/pages/profile/components/ExchangeModal.tsx'
// import InvitationComponent from '@/pages/profile/components/InvitationComponent.tsx'
import { PwChangeModal } from '@/pages/profile/components/PwChangeModal.tsx'
import { useUserStore } from '@/stores/user'
import { formatUserName } from '@/utils/formatter'

import { DeleteSshPubKeyModal } from './components/DeleteSshPubKeyModal'
import { EditSshPubKeyModal } from './components/EditSshPubKeyModal'
import SshPubKeyComponent from './components/SshPubKeyComponent'

export function ProfilePage() {
  const userStore = useUserStore()
  const { t } = useTranslation()
  const [exchangeModalOpen, setExchangeModalOpen] = useState(false)
  const [pwChangeModalOpen, setPwChangeModalOpen] = useState(false)
  const [deleteSshPubKeyModalOpen, setDeleteSshPubKeyModalOpen] = useState(false)
  const [editSshPubKeyModalOpen, setEditSshPubKeyModalOpen] = useState(false)
  // const [eduVerify, setEduVerify] = useState<EduVerify | undefined>(undefined)

  const items = [
    {
      key: 'SshPublicKey',
      icon: KeyIcon,
      title: t('profile.sshPubKey.title'),
      desc: t('profile.sshPubKey.desc'),
      showAction: false,
      additionalComponent: userStore.sshPubKey.length > 0 ? <SshPubKeyComponent /> : null,
      customAction:
        userStore.sshPubKey === '' ? (
          <div>
            <AntButton
              className="min-w-[110px] h-[44px] t-sb border border-neutral-200"
              onClick={() => setEditSshPubKeyModalOpen(true)}
            >
              <Trans i18nKey="profile.sshPubKey.addBtn">New SSH Key</Trans>
            </AntButton>
          </div>
        ) : (
          <div className="flex gap-x-4">
            <AntButton
              className="min-w-[110px] h-[44px] t-sb border border-neutral-200"
              onClick={() => setEditSshPubKeyModalOpen(true)}
            >
              <Trans i18nKey="profile.sshPubKey.updateBtn">Update key</Trans>
            </AntButton>
            <AntButton
              className="min-w-[110px] h-[44px] t-sb border border-error text-error hover:!border-error hover:!text-error"
              onClick={() => setDeleteSshPubKeyModalOpen(true)}
            >
              <Trans i18nKey="profile.sshPubKey.deleteBtn">Delete Key</Trans>
            </AntButton>
          </div>
        ),
    },
  ]

  useEffect(() => {
    userStore.getSshPubKey()
  }, [])

  return (
    <div className="flex flex-col h-full">
      <div className="card overflow-clip bg-panel-white relative flex items-center gap-x-4 bg-[url('@/assets/images/bg-account-assets.png')] bg-repeat bg-auto">
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(88deg, rgba(255, 255, 255, 0.80) 0%, rgba(255, 255, 255, 0.00) 100%)',
          }}
        ></div>
        <div className="relative">
          <div className="text-primary flex flex-1 gap-x-4">
            {/* <Avatar size={80} name={userStore.name} variant="beam" colors={['#525866']} /> */}
            <UserAvatar size={80} />
            <div>
              <h6 className="mt-4 h6">{formatUserName(userStore.name)}</h6>
              <div className="font-semibold text-sm">{userStore.name}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="card bg-white mt-2.5 h-full overflow-y-auto">
        <div className="flex items-center gap-x-8 h6">
          <h6 className="text-primary">
            <Trans i18nKey="profile.accountSetting">Account Setting</Trans>
          </h6>
        </div>
        <div className="my-8 border-b border-gray100"></div>
        <div className=" flex flex-col gap-y-2">
          {items.map((item) => {
            return (
              <div key={item.key} className="flex items-center py-4 gap-x-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-neutral-50 flex self-start items-center justify-center">
                  <item.icon className="w-6 h-6 text-tertiary" />
                </div>
                <div className="flex-grow">
                  <div className="flex justify-between items-center">
                    <div className="">
                      <div className="t-bold text-primary">{item.title}</div>
                      <div className="t-xs text-secondary">{item.desc}</div>
                    </div>
                    {/* {item.showAction && (
                      <AntButton
                        className="min-w-[110px] h-[44px] t-sb border border-neutral-200"
                        onClick={item.action}
                      >
                        {item.actionTitle}
                      </AntButton>
                    )} */}
                    {item.customAction && <div>{item.customAction}</div>}
                  </div>
                  {item.additionalComponent && (
                    <div className="mt-3">{item.additionalComponent}</div>
                  )}
                </div>
                {/* <div className="t-x-m text-orange-500">{item.tailing}</div> */}
              </div>
            )
          })}
        </div>
      </div>

      {exchangeModalOpen && (
        <ExchangeModal
          onOk={() => setExchangeModalOpen(false)}
          onClose={() => setExchangeModalOpen(false)}
        />
      )}

      {pwChangeModalOpen && (
        <PwChangeModal
          onOk={() => setPwChangeModalOpen(false)}
          onClose={() => setPwChangeModalOpen(false)}
        />
      )}

      {deleteSshPubKeyModalOpen && (
        <DeleteSshPubKeyModal onClose={() => setDeleteSshPubKeyModalOpen(false)} />
      )}

      {editSshPubKeyModalOpen && (
        <EditSshPubKeyModal
          isEdit={userStore.sshPubKey !== ''}
          onClose={() => setEditSshPubKeyModalOpen(false)}
        />
      )}
    </div>
  )
}
